module.exports = __webpack_public_path__ + "img/134.73d902f6.jpg";